import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyNumberList,
  PolicySectionTitle,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ServiceId = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "id";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          ID
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/service">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/service">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/service">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/service">TH</Link>
            </li>
            <li className="selected">
              <em>ID</em>
            </li>
            <li>
              <Link to="/policy/es/service">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>
        Syarat dan Ketentuan Penggunaan pregnancy&amp;baby
      </PolicyTitle>

      <PolicyVersion>
        Tanggal Berlaku: [21 September 2026]
        <br />
        Terakhir Diperbarui: [25 Agustus 2026]
      </PolicyVersion>

      <PolicySectionTitle>
        Bab 1. Selamat Datang di pregnancy&amp;baby
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> menyediakan berbagai layanan untuk
        mendukung pengguna selama masa persiapan kehamilan, perawatan kesuburan,
        kehamilan, persalinan, pemulihan pascapersalinan, dan perawatan anak.
        Layanan tersebut dapat mencakup pencatatan kesehatan dan jurnal, laporan
        yang dipersonalisasi, konten informatif, fitur komunitas, dan fungsi
        terkait lainnya.
      </PolicyText>
      <PolicyText>
        Syarat dan Ketentuan Penggunaan ini (“Ketentuan”) mengatur penggunaan
        aplikasi seluler <strong>pregnancy&amp;baby</strong>, situs web, dan
        layanan terkait (secara bersama-sama disebut “Layanan”) yang disediakan
        oleh Connecti Co., Ltd. (“Perusahaan”, “kami”, atau “milik kami”).
      </PolicyText>
      <PolicyText>
        Harap membaca Ketentuan ini dengan saksama sebelum menggunakan Layanan.
      </PolicyText>

      <PolicyArticleTitle>Pasal 1. Tujuan dan Definisi</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Ketentuan ini mengatur hak, kewajiban, tanggung jawab, syarat
          penggunaan, dan hal-hal lain yang berkaitan dengan penggunaan Layanan
          antara Perusahaan dan pengguna yang menyetujui Ketentuan ini serta
          menyelesaikan pendaftaran akun (“Anggota”).
        </li>
        <li>
          Dalam Ketentuan ini, istilah-istilah berikut memiliki arti sebagai
          berikut:
          <PolicyHyphenList>
            <li>
              <strong>“Layanan”</strong> berarti aplikasi seluler
              pregnancy&amp;baby, situs web, dan layanan terkait yang disediakan
              oleh Perusahaan.
            </li>
            <li>
              <strong>“Anggota”</strong> berarti pengguna yang menyetujui
              Ketentuan ini dan menyelesaikan pendaftaran untuk menggunakan
              Layanan.
            </li>
            <li>
              <strong>“Akun”</strong> berarti akun yang digunakan Anggota untuk
              mengakses dan menggunakan Layanan.
            </li>
            <li>
              <strong>“Informasi Akun”</strong> berarti informasi yang berkaitan
              dengan Akun Anggota yang dapat dilihat atau dikelola melalui
              Layanan.
            </li>
            <li>
              <strong>“Konten”</strong> berarti teks, gambar, foto, video, data,
              informasi, komentar, postingan, dan materi lain yang tersedia
              melalui atau diunggah, dikirim, atau diposting ke Layanan.
            </li>
            <li>
              <strong>“Layanan Berbayar”</strong> berarti konten digital, fitur,
              laporan, atau layanan lain yang disediakan oleh Perusahaan dan
              tersedia melalui <strong>pembayaran satu kali.</strong>
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 2. Keberlakuan dan Perubahan Ketentuan
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Ketentuan ini mulai berlaku ketika ditampilkan melalui Layanan atau
          melalui cara lain yang sesuai dan Anggota menyetujuinya.
        </li>
        <li>
          Perusahaan dapat mengubah Ketentuan ini sejauh diizinkan oleh hukum
          yang berlaku.
        </li>
        <li>
          Jika Ketentuan diubah, pada umumnya Perusahaan akan memberitahukan
          perubahan dan tanggal berlakunya setidaknya{" "}
          <strong>15 hari sebelum</strong> Ketentuan yang diubah mulai berlaku.
        </li>
        <li>
          Jika perubahan menimbulkan kerugian material bagi Anggota, pada
          umumnya Perusahaan akan memberikan pemberitahuan setidaknya{" "}
          <strong>30 hari sebelum</strong> tanggal berlakunya melalui email,
          pemberitahuan dalam aplikasi, notifikasi push, atau sarana elektronik
          lain yang sesuai.
        </li>
        <li>
          Jika diizinkan oleh hukum yang berlaku, apabila Perusahaan dengan
          jelas memberitahukan bahwa tidak adanya keberatan dalam jangka waktu
          tertentu akan dianggap sebagai persetujuan terhadap Ketentuan yang
          diubah, dan Anggota tidak menyampaikan keberatan dalam jangka waktu
          tersebut, Anggota dapat dianggap telah menyetujui Ketentuan yang
          diubah.
        </li>
        <li>
          Jika Anggota tidak menyetujui Ketentuan yang diubah, Anggota dapat
          mengakhiri perjanjian penggunaan Layanan dengan menghapus Akun.
        </li>
        <li>
          Ketentuan ini pada umumnya berlaku sejak tanggal Anggota menyetujuinya
          sampai perjanjian penggunaan Layanan berakhir. Ketentuan yang
          berdasarkan sifatnya dimaksudkan untuk tetap berlaku setelah
          pengakhiran dapat tetap berlaku setelah perjanjian berakhir.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Pasal 3. Aturan Tambahan</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Hal-hal yang tidak secara tegas diatur dalam Ketentuan ini akan tunduk
          pada hukum yang berlaku, ketentuan layanan individual, serta kebijakan
          operasional, pedoman, dan aturan Perusahaan (“Kebijakan Operasional”).
        </li>
        <li>
          Jika suatu layanan tertentu tunduk pada ketentuan tambahan, ketentuan
          tambahan tersebut akan berlaku untuk layanan yang bersangkutan.
        </li>
        <li>
          Jika Ketentuan ini bertentangan dengan ketentuan hukum yang bersifat
          wajib, ketentuan hukum tersebut akan berlaku lebih dahulu.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>
        Bab 2. Pendaftaran Keanggotaan dan Pengelolaan Akun
      </PolicySectionTitle>
      <PolicyArticleTitle>Pasal 4. Pendaftaran</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Pengguna dianggap telah menyetujui Ketentuan ini ketika memilih tombol
          atau kotak centang “Setuju”, “Accept”, “Continue”, atau pilihan lain
          yang setara yang ditampilkan selama proses pendaftaran.
        </li>
        <li>
          Untuk mendaftar menggunakan Layanan, pengguna harus memberikan
          informasi yang diperlukan dan menyelesaikan prosedur pendaftaran yang
          ditentukan oleh Perusahaan.
        </li>
        <li>
          Anggota dapat membuat atau mengakses Akun melalui metode yang didukung
          oleh Perusahaan, termasuk:
          <PolicyHyphenList>
            <li>Email</li>
            <li>Google</li>
            <li>Apple</li>
          </PolicyHyphenList>
        </li>
        <li>
          Perusahaan dapat meminta informasi tambahan atau verifikasi jika
          secara wajar diperlukan untuk menyediakan fitur tertentu, melindungi
          Anggota, mematuhi hukum yang berlaku, atau mencegah penyalahgunaan
          Layanan.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 5. Persetujuan, Penangguhan, dan Penolakan Pendaftaran
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Pendaftaran selesai ketika pengguna mengajukan permohonan pendaftaran
          dan Perusahaan menyetujuinya.
        </li>
        <li>
          Pada umumnya, Perusahaan akan menyetujui permohonan pendaftaran yang
          telah diselesaikan dengan benar. Namun, Perusahaan dapat menangguhkan,
          menolak, atau membatalkan pendaftaran jika:
          <PolicyHyphenList>
            <li>
              Pemohon menggunakan identitas, alamat email, Akun, atau informasi
              milik orang lain tanpa izin;
            </li>
            <li>
              Pemohon memberikan informasi palsu, tidak lengkap, atau
              menyesatkan;
            </li>
            <li>
              Perusahaan tidak memiliki kapasitas teknis yang wajar untuk
              menyediakan Layanan;
            </li>
            <li>
              Masalah teknis atau operasional menghalangi penyediaan Layanan;
            </li>
            <li>
              Seseorang yang sebelumnya telah ditangguhkan atau dibatasi dalam
              menggunakan Layanan mencoba menghindari pembatasan tersebut dengan
              membuat Akun lain;
            </li>
            <li>
              Pendaftaran melanggar hukum yang berlaku, Ketentuan ini, atau
              Kebijakan Operasional; atau
            </li>
            <li>
              Perusahaan secara wajar menentukan bahwa pendaftaran tidak dapat
              diterima karena alasan teknis, keamanan, operasional, atau hukum
              yang sah.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Jika setelah pendaftaran Perusahaan menemukan bahwa Anggota terdaftar
          dengan melanggar Pasal ini, Perusahaan dapat membatasi penggunaan
          Layanan, menangguhkan Akun, atau menghapus Akun sesuai keadaan.
        </li>
      </PolicyNumberList>
      <PolicyArticleTitle>Pasal 6. Pengelolaan Akun</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota bertanggung jawab untuk mengelola Akunnya dengan semestinya
          dan mencegah penggunaan tanpa izin oleh pihak ketiga.
        </li>
        <li>
          Jika Anggota mengetahui adanya akses atau penggunaan Akun tanpa izin,
          Anggota harus segera mengambil langkah yang wajar untuk mengamankan
          Akun dan memberitahukan kepada Perusahaan.
        </li>
        <li>
          Anggota dapat melihat atau mengubah Informasi Akun tertentu melalui
          Layanan. Informasi tertentu mungkin tidak dapat diubah secara langsung
          jika pembatasan diperlukan untuk keamanan Akun, identifikasi, atau
          alasan teknis.
        </li>
        <li>
          Jika Anggota perlu memperbarui informasi yang tidak dapat diubah
          secara langsung, Anggota dapat menghubungi Dukungan Pelanggan.
        </li>
        <li>
          Saat Anggota menggunakan login melalui Google, Apple, autentikasi
          dilakukan menggunakan token atau mekanisme autentikasi lain yang
          disediakan oleh layanan pihak ketiga terkait. Perusahaan tidak
          menyediakan pemulihan kata sandi untuk kredensial login yang dikelola
          oleh penyedia pihak ketiga tersebut.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Bab 3. Penggunaan Layanan</PolicySectionTitle>
      <PolicyArticleTitle>Pasal 7. Penyediaan Layanan</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota dapat menggunakan Layanan setelah menyelesaikan pendaftaran
          dan prosedur yang diperlukan untuk fitur terkait.
        </li>
        <li>
          Layanan dapat mencakup, antara lain:
          <PolicyHyphenList>
            <li>Persiapan kehamilan dan pencatatan siklus menstruasi</li>
            <li>Pencatatan dan analisis tes ovulasi dan tes kehamilan</li>
            <li>Pencatatan perawatan kesuburan</li>
            <li>Jurnal kehamilan dan laporan terkait kehamilan</li>
            <li>Laporan pertumbuhan janin</li>
            <li>
              Pengelolaan berat badan selama kehamilan dan pascapersalinan
            </li>
            <li>Fitur pertumbuhan dan perkembangan anak</li>
            <li>Pencatatan kesehatan dan perawatan anak</li>
            <li>Panduan dan konten informatif</li>
            <li>Fitur komunitas</li>
            <li>Fitur lain yang disediakan oleh Perusahaan</li>
          </PolicyHyphenList>
        </li>
        <li>
          Fitur tertentu dapat memerlukan:
          <PolicyHyphenList>
            <li>Informasi tambahan;</li>
            <li>
              Persetujuan terpisah, termasuk persetujuan terkait pemrosesan
              informasi kesehatan atau Data Pribadi sensitif lainnya;
            </li>
            <li>Persyaratan usia atau kelayakan;</li>
            <li>Ketentuan atau kebijakan tambahan; atau</li>
            <li>
              Persyaratan wajar lainnya yang diperlukan untuk menyediakan fitur
              tersebut.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Perusahaan dapat menyediakan pembaruan perangkat lunak untuk
          meningkatkan atau mengubah Layanan atau menambah maupun menghapus
          fitur. Anggota dianjurkan menggunakan versi aplikasi terbaru jika
          memungkinkan.
        </li>
        <li>
          Perusahaan dapat menampilkan pemberitahuan layanan, pesan
          administratif, konten informatif, atau komunikasi lain di dalam
          Layanan.
        </li>
        <li>
          Email, notifikasi push, atau komunikasi serupa untuk tujuan komersial
          atau promosi akan dikirim sesuai dengan persetujuan Anggota dan hukum
          yang berlaku.
        </li>
        <li>
          Jika Anggota menemukan kesalahan sistem atau masalah lain saat
          menggunakan Layanan, Anggota dapat menghubungi Dukungan Pelanggan di:
          <br />
          <a href="mailto:after10month@connect-i.co.kr">
            after10month@connect-i.co.kr
          </a>
        </li>
        <li>
          Anggota bertanggung jawab atas biaya data atau telekomunikasi yang
          dibebankan oleh penyedia layanan internet atau operator seluler
          sehubungan dengan penggunaan Layanan.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 8. Penangguhan, Perubahan, dan Penghentian Layanan
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Perusahaan akan melakukan upaya yang wajar untuk menyediakan Layanan
          secara terus-menerus dan andal.
        </li>
        <li>
          Kecuali diwajibkan lain oleh hukum, seluruh atau sebagian Layanan
          dapat sementara dibatasi, ditangguhkan, diubah, atau dihentikan dalam
          keadaan berikut:
          <PolicyHyphenList>
            <li>
              Pemeliharaan, pemeriksaan, perbaikan, atau penggantian sistem atau
              peralatan;
            </li>
            <li>
              Pemadaman listrik, kegagalan peralatan, kepadatan jaringan, atau
              masalah teknis lainnya;
            </li>
            <li>
              Pengakhiran atau perubahan perjanjian dengan penyedia layanan
              pihak ketiga;
            </li>
            <li>Perintah pemerintah, peraturan, atau persyaratan hukum;</li>
            <li>Perubahan kebijakan operasional, keamanan, atau layanan;</li>
            <li>
              Bencana alam, keadaan darurat, perang, gangguan sipil, atau
              peristiwa force majeure lainnya; atau
            </li>
            <li>
              Keadaan lain yang membuat kelanjutan penyediaan Layanan menjadi
              tidak praktis.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Jika secara wajar memungkinkan, Perusahaan akan memberikan
          pemberitahuan sebelumnya mengenai penangguhan atau penghentian
          material melalui metode yang dijelaskan dalam Pasal 21.
        </li>
        <li>
          Pemberitahuan sebelumnya mungkin tidak dapat diberikan jika
          penangguhan terjadi akibat keadaan yang tidak terduga atau di luar
          kendali, seperti kegagalan server, gangguan sistem, insiden keamanan,
          atau kegagalan sistem pihak ketiga.
        </li>
        <li>
          Dalam keadaan tersebut, Perusahaan akan melakukan upaya yang wajar
          untuk memulihkan Layanan sesegera mungkin.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 9. Pengelolaan Konten Anggota
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Jika Konten yang diposting oleh Anggota melanggar hak cipta, privasi,
          kekayaan intelektual, atau hak lainnya, pemegang hak dapat meminta
          tindakan yang sesuai berdasarkan hukum yang berlaku.
        </li>
        <li>
          Perusahaan dapat membatasi akses terhadap, menghapus sementara, atau
          menghapus secara permanen Konten apabila secara wajar menentukan bahwa
          Konten tersebut:
          <PolicyHyphenList>
            <li>Melanggar hukum yang berlaku;</li>
            <li>Melanggar hak orang lain;</li>
            <li>Melanggar Ketentuan ini atau Kebijakan Operasional;</li>
            <li>
              Mengancam keamanan atau pengoperasian Layanan yang semestinya;
              atau
            </li>
            <li>
              Memerlukan tindakan untuk melindungi Anggota atau pihak ketiga.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Prosedur terkait pelaporan, penghapusan, dan tindakan terkait Konten
          lainnya dapat diatur lebih lanjut dalam Kebijakan Operasional.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 10. Kepemilikan dan Penggunaan Konten
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota dapat mengunggah foto, teks, informasi, video, komentar,
          saran, dan Konten lainnya ke Layanan.
        </li>
        <li>
          Anggota tetap memiliki hak kekayaan intelektual yang mereka miliki
          atas Konten yang mereka unggah.
        </li>
        <li>
          Dengan mengunggah Konten ke area Layanan yang dimaksudkan untuk
          dibagikan kepada orang lain, Anggota memberikan kepada Perusahaan
          lisensi non-eksklusif untuk meng-host, menyimpan, menggandakan,
          menampilkan, memformat, dan secara teknis memodifikasi Konten tersebut
          sejauh yang secara wajar diperlukan untuk mengoperasikan, menampilkan,
          menyediakan, dan meningkatkan fitur terkait.
        </li>
        <li>
          Konten Anggota dapat muncul dalam hasil pencarian, feed, area konten
          yang dipersonalisasi, atau lokasi lain dalam Layanan yang sesuai
          dengan fitur tempat Konten tersebut diunggah.
        </li>
        <li>
          Perusahaan dapat menolak, membatasi, atau menghapus Konten tanpa
          pemberitahuan sebelumnya jika secara wajar menentukan bahwa Konten
          tersebut:
          <PolicyHyphenList>
            <li>Melanggar hukum;</li>
            <li>Bersifat cabul atau eksploitasi seksual;</li>
            <li>
              Mendorong kebencian, diskriminasi yang melanggar hukum, atau
              kekerasan;
            </li>
            <li>Merupakan spam atau iklan tanpa izin;</li>
            <li>Menyamar sebagai orang lain;</li>
            <li>Melanggar hak pihak ketiga;</li>
            <li>Bersifat penipuan atau menyesatkan; atau</li>
            <li>Melanggar Ketentuan ini atau Kebijakan Operasional.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Perusahaan tidak berkewajiban meninjau terlebih dahulu seluruh Konten
          Anggota.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 11. Pembatasan dan Larangan Penggunaan
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota dilarang melakukan hal-hal berikut:
          <PolicyHyphenList>
            <li>
              Memberikan informasi palsu atau secara tidak semestinya
              menggunakan Akun atau identitas orang lain;
            </li>
            <li>
              Menyalin, memodifikasi, mendistribusikan, menjual, mengalihkan,
              meminjamkan, melakukan reverse engineering, dekompilasi, atau
              mencoba mengambil kode sumber dari Layanan tanpa izin, kecuali
              secara tegas diizinkan oleh hukum yang berlaku;
            </li>
            <li>
              Memfitnah, mengancam, melecehkan, atau dengan cara lain merugikan
              orang lain;
            </li>
            <li>
              Mengunggah materi yang melanggar hukum, cabul, eksploitatif, atau
              dilarang lainnya;
            </li>
            <li>
              Melanggar hak cipta, merek dagang, hak privasi, atau hak lain
              milik Perusahaan atau pihak ketiga;
            </li>
            <li>
              Mempublikasikan informasi palsu atau menyesatkan mengenai
              Perusahaan atau orang lain;
            </li>
            <li>
              Menyebarkan Konten yang bertentangan dengan hukum yang berlaku
              atau ketertiban umum;
            </li>
            <li>
              Memasukkan malware, virus, kode berbahaya, atau materi lain yang
              dirancang untuk merusak atau mengganggu Layanan;
            </li>
            <li>
              Dengan sengaja mengganggu atau menghambat pengoperasian normal
              Layanan;
            </li>
            <li>
              Menyamar sebagai orang lain atau secara palsu menyatakan hubungan
              dengan orang atau organisasi lain;
            </li>
            <li>
              Mengumpulkan, menyimpan, atau mengungkapkan Data Pribadi Anggota
              lain secara terbuka tanpa kewenangan yang sah;
            </li>
            <li>
              Menyebarkan informasi penipuan untuk keuntungan finansial atau
              untuk menimbulkan kerugian;
            </li>
            <li>
              Terlibat dalam perjudian ilegal atau kegiatan ilegal lainnya;
            </li>
            <li>
              Menawarkan atau memfasilitasi layanan seksual ilegal atau perilaku
              eksploitatif;
            </li>
            <li>
              Berulang kali mengirim Konten yang dimaksudkan untuk menimbulkan
              rasa takut, penghinaan, pelecehan, atau tekanan serius;
            </li>
            <li>
              Mengirimkan atau mempublikasikan informasi yang dilarang oleh
              hukum yang berlaku;
            </li>
            <li>
              Menyamar sebagai staf Perusahaan, administrator layanan, atau
              mitra bisnis;
            </li>
            <li>
              Menyalahgunakan sistem pelaporan melalui laporan palsu atau
              beritikad buruk;
            </li>
            <li>
              Melakukan stalking, tindakan kasar, atau dengan cara lain
              mengganggu penggunaan Layanan oleh Anggota lain; atau
            </li>
            <li>
              Dengan cara lain melanggar hukum yang berlaku, Ketentuan ini, atau
              Kebijakan Operasional.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Akses ke Layanan tertentu dapat dibatasi berdasarkan usia, kelayakan,
          yurisdiksi, atau persyaratan hukum lainnya.
        </li>
        <li>
          Jika Anggota melanggar Pasal ini, Perusahaan dapat menyelidiki
          pelanggaran tersebut dan dapat menghapus Konten, membatasi fitur
          tertentu sementara atau permanen, menangguhkan Akun, atau mengakhiri
          perjanjian penggunaan Layanan.
        </li>
        <li>
          Perusahaan dapat segera mengambil tindakan yang lebih tegas dalam
          kasus tindakan melanggar hukum yang serius, kerugian besar terhadap
          orang lain, ancaman terhadap keselamatan, risiko keamanan, atau
          pelanggaran berulang.
        </li>
        <li>
          Anggota dapat menghubungi Dukungan Pelanggan untuk meminta peninjauan
          atas pembatasan yang diberlakukan oleh Perusahaan.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 12. Pengakhiran Perjanjian Penggunaan Layanan
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Ketika Anggota menghapus Akun, perjanjian penggunaan Layanan antara
          Anggota dan Perusahaan juga berakhir.
        </li>
        <li>
          Anggota dapat meminta penghapusan Akun kapan saja melalui fungsi yang
          tersedia dalam Layanan atau dengan menghubungi Dukungan Pelanggan.
        </li>
        <li>
          Setelah pengakhiran, informasi Anggota dan data Layanan akan ditangani
          sesuai dengan hukum yang berlaku dan{" "}
          <strong>Kebijakan Privasi pregnancy&amp;baby</strong>.
        </li>
        <li>
          Data Pribadi yang dapat mengidentifikasi Anggota akan dihapus sesuai
          dengan Kebijakan Privasi, kecuali penyimpanan diwajibkan atau
          diizinkan oleh hukum yang berlaku.
        </li>
        <li>
          Data Layanan tertentu dapat dianonimkan secara permanen dan disimpan
          untuk tujuan penelitian, statistik, analisis, dan peningkatan layanan
          sebagaimana dijelaskan dalam Kebijakan Privasi.
        </li>
        <li>
          Konten yang telah dibagikan secara publik atau dengan Anggota lain,
          termasuk postingan dan komentar komunitas, mungkin tidak secara
          otomatis dihapus ketika Akun dihapus jika Konten tersebut menjadi
          bagian dari percakapan, interaksi, atau area berbagi Anggota lain.
        </li>
        <li>
          Anggota dianjurkan menghapus Konten yang ingin dihapus sebelum
          menghapus Akun. Jika Konten tetap ada setelah penghapusan Akun,
          Informasi Akun yang dapat mengidentifikasi Anggota, seperti nama
          panggilan, dapat dihapus atau dipisahkan sebagaimana mestinya.
        </li>
        <li>
          Jika Anggota menggunakan penyedia login pihak ketiga seperti Google,
          Apple dan menghapus atau memutuskan hubungan Akun pihak ketiga
          tersebut, akses ke pregnancy&amp;baby melalui metode login tersebut
          mungkin tidak lagi tersedia.
        </li>
        <li>
          Data yang dihapus akibat penghapusan Akun pada umumnya tidak dapat
          dipulihkan.
        </li>
        <li>
          Mantan Anggota dapat mendaftar untuk membuat Akun baru kecuali
          pendaftaran ulang dibatasi karena pelanggaran sebelumnya terhadap
          hukum yang berlaku, Ketentuan ini, atau Kebijakan Operasional.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 13. Perlindungan Data Pribadi
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Perusahaan memproses Data Pribadi sejauh diperlukan untuk menyediakan
          Layanan dan sesuai dengan hukum privasi dan perlindungan data yang
          berlaku.
        </li>
        <li>
          Data Pribadi hanya akan diproses untuk tujuan dan dalam lingkup yang
          dijelaskan dalam Kebijakan Privasi Perusahaan, pemberitahuan
          persetujuan terkait, dan pemberitahuan lain yang diwajibkan oleh
          hukum.
        </li>
        <li>
          Jika suatu fitur memerlukan pemrosesan informasi kesehatan atau Data
          Pribadi sensitif lainnya, Perusahaan akan memperoleh persetujuan yang
          diwajibkan oleh hukum yang berlaku.
        </li>
        <li>
          Perusahaan tidak akan mengungkapkan Data Pribadi kepada pihak ketiga
          independen kecuali:
          <PolicyHyphenList>
            <li>Dengan persetujuan Anggota;</li>
            <li>Sebagaimana dijelaskan dalam Kebijakan Privasi;</li>
            <li>
              Kepada penyedia layanan yang memproses data atas nama Perusahaan;
            </li>
            <li>Jika diwajibkan atau diizinkan oleh hukum; atau</li>
            <li>Dalam keadaan lain yang diizinkan secara hukum.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Informasi lebih rinci mengenai pengumpulan, penggunaan, pembagian,
          penyimpanan, transfer internasional, dan perlindungan Data Pribadi
          oleh Perusahaan tercantum dalam{" "}
          <strong>Kebijakan Privasi pregnancy&amp;baby</strong>.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Bab 4. Layanan Berbayar</PolicySectionTitle>
      <PolicyArticleTitle>
        Pasal 14. Informasi tentang Layanan Berbayar
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Jika Perusahaan menawarkan Layanan Berbayar, Anggota dapat mengakses
          layanan tersebut dengan membayar <strong>biaya satu kali</strong>{" "}
          sesuai dengan ketentuan yang ditampilkan untuk Layanan Berbayar
          terkait.
        </li>
        <li>
          Sebelum pembelian diselesaikan, Perusahaan atau app marketplace yang
          berlaku akan menyediakan secara wajar informasi utama seperti:
          <PolicyHyphenList>
            <li>Nama atau deskripsi Layanan Berbayar;</li>
            <li>Penyedia Layanan Berbayar;</li>
            <li>Isi dan fitur utama Layanan Berbayar;</li>
            <li>Harga yang berlaku; dan</li>
            <li>
              Ketentuan pembelian material lainnya yang diwajibkan oleh hukum
              yang berlaku.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Ketersediaan Layanan Berbayar dapat bergantung pada perangkat, sistem
          operasi, negara, app marketplace, dan persyaratan teknis lainnya milik
          pengguna.
        </li>
        <li>
          Kecuali dinyatakan secara tegas sebaliknya, Layanan Berbayar merupakan{" "}
          <strong>
            pembelian satu kali dan tidak diperpanjang secara otomatis atau
            menimbulkan biaya berulang
          </strong>
          .
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 15. Terbentuknya Perjanjian Layanan Berbayar
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota dapat membeli Layanan Berbayar melalui prosedur pembelian yang
          disediakan oleh Perusahaan atau app marketplace terkait.
        </li>
        <li>
          Proses pembelian dapat mencakup:
          <PolicyHyphenList>
            <li>Meninjau dan memilih Layanan Berbayar;</li>
            <li>Meninjau harga dan ketentuan material;</li>
            <li>Memilih metode pembayaran yang tersedia;</li>
            <li>Mengonfirmasi pembelian; dan</li>
            <li>Menyelesaikan pembayaran.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Perjanjian Layanan Berbayar terbentuk ketika pembelian berhasil
          diselesaikan dan konfirmasi ditampilkan atau diberikan dengan cara
          lain.
        </li>
        <li>
          Perusahaan dapat menolak, membatalkan, atau menangguhkan transaksi
          jika:
          <PolicyHyphenList>
            <li>Informasi palsu atau tanpa kewenangan digunakan;</li>
            <li>
              Metode pembayaran tidak digunakan dengan kewenangan yang sah;
            </li>
            <li>
              Anggota secara hukum tidak diperbolehkan melakukan transaksi;
            </li>
            <li>Masalah teknis atau operasional mencegah penyelesaian;</li>
            <li>Akun Anggota sedang ditangguhkan atau dibatasi; atau</li>
            <li>
              Transaksi melanggar hukum yang berlaku, Ketentuan ini, atau
              kebijakan marketplace yang berlaku.
            </li>
          </PolicyHyphenList>
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 16. Pembayaran untuk Layanan Berbayar
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Metode pembayaran yang tersedia dapat berbeda tergantung negara,
          perangkat, platform, dan metode pembayaran yang didukung oleh app
          marketplace atau penyedia pembayaran terkait.
        </li>
        <li>
          Jika Layanan Berbayar dibeli melalui aplikasi seluler, pembayaran
          dapat diproses sebagai{" "}
          <strong>
            pembelian dalam aplikasi satu kali (one-time in-app purchase)
          </strong>{" "}
          melalui:
          <PolicyHyphenList>
            <li>Apple App Store</li>
            <li>Google Play</li>
          </PolicyHyphenList>
        </li>
        <li>
          Pembayaran melalui app marketplace tunduk pada ketentuan pembayaran,
          aturan penagihan, prosedur pembatalan, kebijakan pengembalian dana,
          dan kebijakan terkait lainnya dari marketplace tersebut.
        </li>
        <li>
          Anggota hanya boleh menggunakan metode pembayaran yang secara sah
          berhak mereka gunakan.
        </li>
        <li>
          Anggota bertanggung jawab memastikan bahwa informasi yang diberikan
          sehubungan dengan pembayaran akurat dan digunakan secara sah.
        </li>
        <li>
          Penyedia pembayaran atau app marketplace dapat memberlakukan batas
          transaksi, pembatasan wilayah, persyaratan usia, atau ketentuan
          lainnya.
        </li>
        <li>
          Perusahaan tidak menyimpan informasi kartu pembayaran secara lengkap
          apabila pembayaran diproses sepenuhnya oleh app marketplace atau
          penyedia pembayaran independen.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 17. Pembatalan dan Penarikan atas Layanan Berbayar
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Kelayakan Anggota untuk membatalkan pembelian, menggunakan hak
          penarikan, atau memperoleh pengembalian dana atas Layanan Berbayar
          akan ditentukan berdasarkan:
          <PolicyHyphenList>
            <li>Hukum perlindungan konsumen yang berlaku;</li>
            <li>Sifat Layanan Berbayar terkait;</li>
            <li>Apakah Layanan Berbayar telah disediakan atau digunakan;</li>
            <li>Ketentuan yang diberitahukan pada saat pembelian; dan</li>
            <li>
              Jika dibeli melalui app marketplace, kebijakan marketplace
              tersebut.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Untuk pembelian melalui Apple App Store atau Google Play, permintaan
          pembatalan, penarikan, atau pengembalian dana mungkin perlu diajukan
          langsung melalui marketplace yang berlaku sesuai kebijakannya.
        </li>
        <li>
          Konten atau layanan digital tertentu mungkin tidak memenuhi syarat
          untuk penarikan atau pengembalian dana setelah penyediaan atau
          penggunaan dimulai apabila diizinkan oleh hukum yang berlaku dan
          seluruh pemberitahuan atau persetujuan yang diwajibkan hukum telah
          diberikan.
        </li>
        <li>
          Tidak ada ketentuan dalam Ketentuan ini yang membatasi hak pembatalan,
          penarikan, atau pengembalian dana yang secara wajib diberikan kepada
          Anggota berdasarkan hukum yang berlaku.
        </li>
        <li>
          Manfaat, kupon, atau manfaat tambahan lain yang diberikan sehubungan
          dengan pembelian yang dikembalikan dananya dapat ditarik atau
          penggunaannya dibatasi sejauh diizinkan oleh hukum yang berlaku.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 18. Pembatasan Penggunaan Layanan Berbayar
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Perusahaan akan menyediakan Layanan Berbayar yang dibeli secara sah
          agar dapat digunakan Anggota sesuai dengan ketentuan yang disampaikan
          untuk layanan tersebut.
        </li>
        <li>
          Perusahaan dapat membatasi atau menangguhkan akses terhadap Layanan
          Berbayar sejauh diizinkan oleh hukum yang berlaku apabila Anggota:
          <PolicyHyphenList>
            <li>Melanggar Ketentuan ini;</li>
            <li>Melakukan kegiatan penipuan atau melanggar hukum;</li>
            <li>Menggunakan metode pembayaran tanpa kewenangan;</li>
            <li>
              Menyalahgunakan sistem pengembalian dana atau pembayaran; atau
            </li>
            <li>
              Melakukan tindakan lain yang memberikan dasar yang wajar untuk
              pembatasan berdasarkan hukum yang berlaku.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Jika sesuai, Anggota dapat menghubungi Dukungan Pelanggan untuk
          meminta peninjauan atas pembatasan tersebut.
        </li>
        <li>
          Pembatasan penggunaan Layanan Berbayar tidak mengakhiri Akun
          pregnancy&amp;baby milik Anggota, kecuali dinyatakan secara tegas
          sebaliknya.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Pasal 19. Pengembalian Dana</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Kelayakan pengembalian dana dan jumlah pengembalian dana bergantung
          pada hukum yang berlaku, jenis Layanan Berbayar, apakah layanan atau
          konten digital telah disediakan atau digunakan, serta kebijakan yang
          disampaikan pada saat pembelian.
        </li>
        <li>
          Jika pembelian diproses melalui{" "}
          <strong>Apple App Store atau Google Play</strong>, kebijakan dan
          prosedur pengembalian dana marketplace yang berlaku pada umumnya akan
          diterapkan, dan Perusahaan mungkin tidak dapat mengeluarkan
          pengembalian dana secara langsung.
        </li>
        <li>
          Konten digital atau layanan tertentu mungkin tidak dapat dikembalikan
          dananya setelah penyediaan atau penggunaan dimulai jika diizinkan oleh
          hukum yang berlaku dan seluruh pemberitahuan atau persetujuan yang
          diwajibkan hukum telah diberikan.
        </li>
        <li>
          Jika kebijakan pengembalian dana terpisah berlaku untuk Layanan
          Berbayar tertentu, Perusahaan akan menyediakan kebijakan tersebut
          selama proses pembelian.
        </li>
        <li>
          Tidak ada ketentuan dalam Pasal ini yang mengecualikan atau membatasi
          hak pengembalian dana, pembatalan, penarikan, atau hak konsumen
          lainnya yang menurut hukum yang berlaku bagi Anggota tidak dapat
          dikecualikan atau dibatasi.
        </li>
      </PolicyNumberList>

      <PolicySectionTitle>Bab 5. Ketentuan Lain</PolicySectionTitle>
      <PolicyArticleTitle>
        Pasal 20. Penafian dan Tanggung Jawab
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Sejauh maksimal yang diizinkan oleh hukum yang berlaku, Perusahaan
          tidak memberikan jaminan atas hal-hal yang tidak secara tegas
          ditetapkan dalam Ketentuan ini.
        </li>
        <li>
          Perusahaan tidak menjamin kelengkapan, keakuratan, keandalan, atau
          kesesuaian untuk tujuan tertentu atas informasi yang diberikan oleh:
          <PolicyHyphenList>
            <li>Anggota;</li>
            <li>Penyedia Konten pihak ketiga;</li>
            <li>Basis data publik;</li>
            <li>Layanan eksternal; atau</li>
            <li>Sumber independen lainnya.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Layanan, termasuk prediksi siklus menstruasi, perkiraan masa subur,
          perhitungan terkait kehamilan, analisis pertumbuhan janin, informasi
          pertumbuhan dan perkembangan anak, serta fitur kesehatan lainnya,
          disediakan untuk{" "}
          <strong>tujuan informasi dan dukungan kepada pengguna</strong>.
        </li>
        <li>
          Layanan tidak merupakan dan tidak dimaksudkan untuk menggantikan
          diagnosis, pemeriksaan, perawatan, atau nasihat medis profesional.
        </li>
        <li>
          Jika kerugian timbul akibat kesengajaan atau kelalaian Perusahaan,
          Perusahaan bertanggung jawab sesuai dengan hukum yang berlaku.
        </li>
        <li>
          Sejauh diizinkan oleh hukum yang berlaku, Perusahaan tidak bertanggung
          jawab atas kerugian yang tidak disebabkan oleh kesengajaan atau
          kelalaian Perusahaan, termasuk kerugian yang semata-mata timbul dari:
          <PolicyHyphenList>
            <li>
              Force majeure atau keadaan di luar kendali wajar Perusahaan;
            </li>
            <li>Tindakan atau kelalaian Anggota sendiri;</li>
            <li>
              Akses tanpa izin atau serangan oleh pihak ketiga yang tidak dapat
              secara wajar dicegah;
            </li>
            <li>
              Malware atau perangkat lunak berbahaya yang diperkenalkan oleh
              pihak ketiga;
            </li>
            <li>
              Kegagalan jaringan, sistem, atau layanan pihak ketiga di luar
              kendali wajar Perusahaan; atau
            </li>
            <li>
              Keadaan lain yang tidak disebabkan oleh kesengajaan atau kelalaian
              Perusahaan.
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          Sejauh diizinkan oleh hukum yang berlaku, Perusahaan tidak bertanggung
          jawab atas sengketa yang timbul semata-mata antara Anggota atau antara
          Anggota dan pihak ketiga independen, kecuali Perusahaan secara hukum
          bertanggung jawab atas masalah tersebut.
        </li>
        <li>
          Tidak ada ketentuan dalam Ketentuan ini yang mengecualikan atau
          membatasi tanggung jawab yang secara hukum tidak dapat dikecualikan
          atau dibatasi berdasarkan perlindungan konsumen atau ketentuan hukum
          wajib lainnya.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 21. Pemberitahuan dan Komunikasi
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Anggota dapat menghubungi Perusahaan melalui Dukungan Pelanggan kapan
          saja terkait Layanan.
        </li>
        <li>
          Pemberitahuan umum kepada Anggota dapat diberikan melalui
          pemberitahuan dalam Layanan selama setidaknya tujuh (7) hari atau
          dengan metode lain yang wajar.
        </li>
        <li>
          Hal-hal yang secara material memengaruhi hak Anggota atau penggunaan
          Layanan dapat dikomunikasikan secara individual melalui:
          <PolicyHyphenList>
            <li>Email;</li>
            <li>Notifikasi push;</li>
            <li>Pesan dalam aplikasi; atau</li>
            <li>Sarana elektronik lain yang sesuai.</li>
          </PolicyHyphenList>
        </li>
        <li>
          Perusahaan tidak berkewajiban menggunakan metode komunikasi yang untuk
          penerimaannya Anggota belum memberikan informasi yang diperlukan.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>
        Pasal 22. Hukum yang Berlaku dan Penyelesaian Sengketa
      </PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Ketentuan ini dan hubungan antara Perusahaan dan Anggota pada umumnya
          tunduk pada hukum <strong>Republik Korea</strong>, tanpa mengurangi
          ketentuan wajib perlindungan konsumen atau hak wajib lainnya
          berdasarkan hukum negara atau wilayah tempat Anggota tinggal.
        </li>
        <li>
          Jika timbul sengketa terkait Layanan, Perusahaan dan Anggota terlebih
          dahulu akan melakukan upaya yang wajar untuk menyelesaikan masalah
          melalui konsultasi dengan itikad baik.
        </li>
        <li>
          Jika sengketa tidak dapat diselesaikan secara damai, sengketa dapat
          diajukan ke pengadilan yang memiliki yurisdiksi berdasarkan hukum yang
          berlaku.
        </li>
        <li>
          Tidak ada ketentuan dalam Ketentuan ini yang menghilangkan hak Anggota
          untuk mengajukan klaim ke pengadilan atau otoritas yang berwenang jika
          hak tersebut dijamin oleh hukum wajib di negara atau wilayah tempat
          Anggota tinggal.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Pasal 23. Ketentuan Umum</PolicyArticleTitle>
      <PolicyNumberList>
        <li>
          Hal-hal yang tidak secara tegas diatur dalam Ketentuan ini akan tunduk
          pada hukum yang berlaku dan, sejauh diizinkan, praktik yang diterima
          secara umum.
        </li>
        <li>
          Jika suatu ketentuan dalam Ketentuan ini dinyatakan tidak sah,
          melanggar hukum, atau tidak dapat dilaksanakan, ketentuan lainnya akan
          tetap berlaku sejauh maksimal yang diizinkan oleh hukum.
        </li>
        <li>
          Kegagalan Perusahaan untuk menegakkan suatu ketentuan dalam Ketentuan
          ini tidak dianggap sebagai pelepasan atas ketentuan tersebut atau hak
          lainnya.
        </li>
        <li>
          Judul-judul dalam Ketentuan ini digunakan semata-mata untuk kemudahan
          dan tidak memengaruhi penafsirannya.
        </li>
      </PolicyNumberList>

      <PolicyArticleTitle>Ketentuan Tambahan</PolicyArticleTitle>
      <PolicyText>
        Ketentuan ini berlaku mulai <strong>[21 September 2026]</strong>.
      </PolicyText>
      <PolicyText>
        Untuk Anggota yang mendaftar setelah Ketentuan ini diumumkan namun
        sebelum Tanggal Berlaku yang dinyatakan, Perusahaan dapat menerapkan
        Ketentuan ini sejak tanggal pendaftaran sejauh diizinkan oleh hukum yang
        berlaku.
      </PolicyText>
    </PolicyContainer>
  );
};

export default ServiceId;
